import { Inject, Injectable } from '@angular/core';
import { Util } from '@libs/utilities/util';

import { AddonPageAddonsRenderer } from '../../shared/page-addons-renderer.helper';
import { EnumAddonPageAddonInjection, IAddonAddOnScriptScript } from '../../shared/page-addons.interface';


@Injectable()
export class AddonGoogleTagManagerScript implements IAddonAddOnScriptScript {

	constructor(
		@Inject(EnumAddonPageAddonInjection.GoogleTagManagerId)
		private tagId		: string,
		private renderHelper: AddonPageAddonsRenderer
	) {}

	create(): AddonGoogleTagManagerScript {

		//0 - check if the GTM was configured
		if (Util.String.isEmpty(this.tagId)) throw new Error(`AddonGoogleTagManagerScript => create => FATAL ERROR: Google Tag Id was not provided in the module (value is: "${this.tagId}")`);

		//1 - define the scripts
		const scriptInnerHtml: string = `
			(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
			new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
			j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
			'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer','${this.tagId}');
		`;

		//2 - defined the img
		const noScriptInnerHtml: string = `
			<iframe src="https://www.googletagmanager.com/ns.html?id=${this.tagId}"
			height="0" width="0" style="display:none;visibility:hidden"></iframe>
		`;

		//3 - add the elements
		this.renderHelper.addScriptToHead('google_tag', { innerHTML: scriptInnerHtml });
		this.renderHelper.addNoScriptToBody('google_tag', { innerHTML: noScriptInnerHtml });
		return this;
	}
}
